// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "celip-88352.firebaseapp.com",
  "projectId": "celip-88352",
  "storageBucket": "celip-88352.appspot.com",
  "messagingSenderId": "989621673036",
  "appId": "1:989621673036:web:cbb735fb6abb280d76a8e9",
  "measurementId": "G-2CFV94JCG5",
  "apiKey": "AIzaSyD6WSo8umy_JRdGwrSH31STsW_tdcAw51o"
};
